export function OutlineUsersIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9324 6.99841C15.9324 7.91521 15.63 8.75521 15.1116 9.42721C14.382 10.3872 13.23 11.0016 11.934 11.0016C10.638 11.0016 9.48595 10.3872 8.75635 9.42721C8.23795 8.75521 7.93555 7.91521 7.93555 6.99841C7.93555 6.84001 7.94515 6.68161 7.96435 6.52801C8.19475 4.5408 9.88435 3 11.934 3C13.9836 3 15.6732 4.5408 15.9036 6.52801C15.9228 6.68161 15.9324 6.84001 15.9324 6.99841Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9358 8.50081C19.9358 9.88321 18.8174 11.0016 17.435 11.0016C16.379 11.0016 15.4814 10.3488 15.1118 9.42721C15.6302 8.75521 15.9326 7.9152 15.9326 6.9984C15.9326 6.84 15.923 6.6816 15.9038 6.528C16.3262 6.1968 16.8542 6 17.435 6C18.8174 6 19.9358 7.1184 19.9358 8.50081Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75663 9.42721C8.38703 10.3488 7.48942 11.0016 6.43342 11.0016C5.05582 11.0016 3.93262 9.88321 3.93262 8.50081C3.93262 7.1184 5.05582 6 6.43342 6C7.01422 6 7.54222 6.1968 7.96463 6.528C7.94543 6.6816 7.93583 6.84 7.93583 6.9984C7.93583 7.9152 8.23823 8.75521 8.75663 9.42721Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.93089 14.002H15.9373C17.0413 14.002 17.9341 14.8948 17.9341 15.9988V21.0004H5.93408V15.9988C5.93408 14.8948 6.82688 14.002 7.93089 14.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9342 18.9977H20.9342V15.9929C20.9342 14.8889 20.0414 13.9961 18.9374 13.9961H15.9326"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.93409 18.9977H2.93408V15.9929C2.93408 14.8889 3.82688 13.9961 4.93089 13.9961H7.93569"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
